<template>
  <div class='boardSearch'>
    <div class='search-bar-div'>
      <b-form-input type="text" v-model="searchString" class='search-input'>
      </b-form-input>
      <b-button class="search-btn" @click="runSearch"><fa icon="search"/></b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'BoardSearch',
  data () {
    return {
      searchString: ''
    }
  },

  computed: {
    ...mapGetters(['currentBoard', 'currentUser'])
  },

  methods: {
    ...mapActions(['loadTickets']),
    runSearch () {
      let params = {
        search: this.searchString
      }
      if (this.currentBoard.id) {
        params.board_id = this.currentBoard.id
      } else {
        params.user_id = this.currentUser.id
      }
      this.loadTickets(params)
    }
  }

}
</script>

<style scoped>
  .search-btn {
      margin: 6px 5px;
      background: none;
      border: none;
      position: absolute;
      top: 0px;
      right: 5px;
      color: #57B2CD;
      outline: none;
  }
  .search-btn:active:focus {
    box-shadow: none !important;
  }
  .search-btn:active {
    background-color: transparent !important;
    color: #57B2CD !important;
  }
  .search-bar-div {
    font-size: 1.5rem;
    line-height: 34px;
    overflow: hidden;
    height: 32;
    text-align:left;
    border-color: #d6dde3;
    border-radius: 5px;
    transition: all .1s ease-in-out;
    -webkit-appearance: none;
    line-height: normal;
    padding: 0 55px;
    position: relative;
    background-color: transparent;
    -moz-appearance: none;
    appearance: none;
    border-color: #d5d5d5;
    border-radius: 30px;
    border-style: solid;
    border-width: 1px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    font-family: inherit;
    margin: 0;
    outline: 0;
    padding: 0;
    position: relative;
    vertical-align: middle;
    width: 100%;
    margin: 8px;
    padding: 0 15px;
  }
  .search-input {
    border: 0;
  }
  .search-input:focus {
    outline: none;
    border-color: inherit;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/BoardSearch.vue